<template>   
        <div class = "background">
        <div class="layer">
            <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" style="height: 80px; position: fixed; top: 0; left: 0; right: 0; z-index: 80;">
                <NavBar v-if="showNavBar" :selectedItem="selectedItem"/>
            </div> 
            <div class="eventDetailInfo">
                <div class="eventTitle">
                    <button 
                        class="close-button" 
                        @click="backToList"
                    >
                        <img :src="require('@/assets/icon/back.png')" alt="icon" class="icon" />
                    </button> 
                    <div class = "title">{{ title }}</div>
                </div>
                <div class="line">

                </div>
                
                
                
                <div class="photo-grid">
                    <div v-for="(column, index) in columns" :key="index" class="photo-column"  >
                        <div class="photo-area" v-for="(photo, photoIndex) in column" :key="photoIndex" >
                            <div class="photo-top"></div>
                            <div class="photo-middle">
                                <div class="photo-left">LE-TIMES</div>
                                <img v-lazy="photo" :alt="`Photo ${photoIndex}`" class="photo" />
                                <div class="photo-right">>> {{ folder }}</div>
                            </div>
                            <div class="photo-bottom"></div>
                        </div> 
                    </div>
                </div>
            </div>
            
            
            
        </div>
    </div>
    
</template>
  
<script>
    import NavBar from './NavBar.vue'
    export default {
        name:"eventDetail",
        components: {
            NavBar,
        },
        props: {

            
        },
    data() {
      return {
        showNavBar: true,
        selectedItem:"OurBusiness",
        item:String,
        title:String,
        folder: "003",
        columns: [[], [], [], []], // 四列布局
        folders:[
            { id: "001", text: "IHG Sanlitun Fashion Night Out" },
            { id: "002", text: "International Temple Fair" },
            { id: "003", text: "Jin Music Concert" },
            { id: "004", text: "White Party" },
            { id: "005", text: "Ye‘ Shanghai" },
            { id: "007", text: "Fairy Tale X'mas Eve Dinner - Snow White and the Seven Dwarfs" },
            { id: "006", text: "NYE Parties" },
            { id: "008", text: "SHEGUANG HU Fashion Night Out @ Regent Beijing"},
        ],
        images : {
            "001":[
            require('@/assets/Event/FashionNight/image_1.jpg'),
            require('@/assets/Event/FashionNight/image_2.jpg'),
            require('@/assets/Event/FashionNight/image_3.jpg'),
            require('@/assets/Event/FashionNight/image_4.jpg'),
            require('@/assets/Event/FashionNight/image_5.jpg'),
            require('@/assets/Event/FashionNight/image_6.jpg'),
            require('@/assets/Event/FashionNight/image_7.jpg'),
            require('@/assets/Event/FashionNight/image_8.jpg'),
            require('@/assets/Event/FashionNight/image_9.jpg'),
            require('@/assets/Event/FashionNight/image_10.jpg'),
            require('@/assets/Event/FashionNight/image_11.jpg'),
            require('@/assets/Event/FashionNight/image_12.jpg'),
            require('@/assets/Event/FashionNight/image_13.jpg'),
            require('@/assets/Event/FashionNight/image_14.jpg'),
            require('@/assets/Event/FashionNight/image_15.jpg'),
            require('@/assets/Event/FashionNight/image_16.jpg'),
            require('@/assets/Event/FashionNight/image_17.jpg'),
            require('@/assets/Event/FashionNight/image_18.jpg'),
            require('@/assets/Event/FashionNight/image_19.jpg'),
            require('@/assets/Event/FashionNight/image_20.jpg'),
            require('@/assets/Event/FashionNight/image_21.jpg'),
            require('@/assets/Event/FashionNight/image_22.jpg'),
            require('@/assets/Event/FashionNight/image_23.jpg'),
            ],
            "002":[
            require('@/assets/Event/InternationalTempleFair/image_1.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_2.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_3.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_4.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_5.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_6.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_7.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_8.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_9.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_10.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_11.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_12.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_13.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_14.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_15.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_16.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_17.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_18.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_19.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_20.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_21.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_22.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_23.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_24.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_25.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_26.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_27.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_28.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_29.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_30.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_31.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_32.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_33.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_34.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_35.jpg'),
            require('@/assets/Event/InternationalTempleFair/image_36.jpg'),
            ],
            "003":[
            require('@/assets/Event/JinMusicConcert/image_1.jpg'),
            require('@/assets/Event/JinMusicConcert/image_2.jpg'),
            require('@/assets/Event/JinMusicConcert/image_3.jpg'),
            require('@/assets/Event/JinMusicConcert/image_4.jpg'),
            require('@/assets/Event/JinMusicConcert/image_5.jpg'),
            require('@/assets/Event/JinMusicConcert/image_6.jpg'),
            require('@/assets/Event/JinMusicConcert/image_7.jpg'),
            require('@/assets/Event/JinMusicConcert/image_8.jpg'),
            require('@/assets/Event/JinMusicConcert/image_9.jpg'),
            require('@/assets/Event/JinMusicConcert/image_10.jpg'),
            ],
            "004":[
            require('@/assets/Event/WhiteParty/image_1.jpg'),
            require('@/assets/Event/WhiteParty/image_2.jpg'),
            require('@/assets/Event/WhiteParty/image_3.jpg'),
            require('@/assets/Event/WhiteParty/image_4.jpg'),
            require('@/assets/Event/WhiteParty/image_5.jpg'),
            require('@/assets/Event/WhiteParty/image_6.jpg'),
            require('@/assets/Event/WhiteParty/image_7.jpg'),
            require('@/assets/Event/WhiteParty/image_8.jpg'),
            require('@/assets/Event/WhiteParty/image_9.jpg'),
            require('@/assets/Event/WhiteParty/image_10.jpg'),
            require('@/assets/Event/WhiteParty/image_11.jpg'),
            require('@/assets/Event/WhiteParty/image_12.jpg'),
            require('@/assets/Event/WhiteParty/image_13.jpg'),
            require('@/assets/Event/WhiteParty/image_14.jpg'),
            require('@/assets/Event/WhiteParty/image_15.jpg'),
            require('@/assets/Event/WhiteParty/image_16.jpg'),
            require('@/assets/Event/WhiteParty/image_17.jpg'),
            ],
            "005":[
            require('@/assets/Event/YeShanghai/image_1.jpg'),
            require('@/assets/Event/YeShanghai/image_2.jpg'),
            require('@/assets/Event/YeShanghai/image_3.jpg'),
            require('@/assets/Event/YeShanghai/image_4.jpg'),
            require('@/assets/Event/YeShanghai/image_5.jpg'),
            require('@/assets/Event/YeShanghai/image_6.jpg'),
            require('@/assets/Event/YeShanghai/image_7.jpg'),
            require('@/assets/Event/YeShanghai/image_8.jpg'),
            require('@/assets/Event/YeShanghai/image_9.jpg'),
            require('@/assets/Event/YeShanghai/image_10.jpg'),
            require('@/assets/Event/YeShanghai/image_11.jpg'),
            require('@/assets/Event/YeShanghai/image_12.jpg'),
            require('@/assets/Event/YeShanghai/image_13.jpg'),
            require('@/assets/Event/YeShanghai/image_14.jpg'),
            require('@/assets/Event/YeShanghai/image_15.jpg'),
            require('@/assets/Event/YeShanghai/image_16.jpg'),
            require('@/assets/Event/YeShanghai/image_17.jpg'),
            require('@/assets/Event/YeShanghai/image_18.jpg'),
            require('@/assets/Event/YeShanghai/image_19.jpg'),
            require('@/assets/Event/YeShanghai/image_20.jpg'),
            require('@/assets/Event/YeShanghai/image_21.jpg'),
            require('@/assets/Event/YeShanghai/image_22.jpg'),
            require('@/assets/Event/YeShanghai/image_23.jpg'),
            require('@/assets/Event/YeShanghai/image_24.jpg'),
            require('@/assets/Event/YeShanghai/image_25.jpg'),
            require('@/assets/Event/YeShanghai/image_26.jpg'),
            require('@/assets/Event/YeShanghai/image_27.jpg'),
            require('@/assets/Event/YeShanghai/image_28.jpg'),
            require('@/assets/Event/YeShanghai/image_29.jpg'),
            require('@/assets/Event/YeShanghai/image_30.jpg'),
            require('@/assets/Event/YeShanghai/image_31.jpg'),
            require('@/assets/Event/YeShanghai/image_32.jpg'),
            require('@/assets/Event/YeShanghai/image_33.jpg'),
            require('@/assets/Event/YeShanghai/image_34.jpg'),
            require('@/assets/Event/YeShanghai/image_35.jpg'),
            require('@/assets/Event/YeShanghai/image_36.jpg'),
            require('@/assets/Event/YeShanghai/image_37.jpg'),
            require('@/assets/Event/YeShanghai/image_38.jpg'),
            require('@/assets/Event/YeShanghai/image_39.jpg'),
            require('@/assets/Event/YeShanghai/image_40.jpg'),
            require('@/assets/Event/YeShanghai/image_41.jpg'),
            require('@/assets/Event/YeShanghai/image_42.jpg'),
            require('@/assets/Event/YeShanghai/image_43.jpg'),
            require('@/assets/Event/YeShanghai/image_44.jpg'),
            ],
            "006":[
            require('@/assets/Event/NYEParties/image_1.jpg'),
            require('@/assets/Event/NYEParties/image_2.jpg'),
            require('@/assets/Event/NYEParties/image_3.jpg'),
            require('@/assets/Event/NYEParties/image_4.jpg'),
            require('@/assets/Event/NYEParties/image_5.jpg'),
            require('@/assets/Event/NYEParties/image_6.jpg'),
            require('@/assets/Event/NYEParties/image_7.jpg'),
            require('@/assets/Event/NYEParties/image_8.jpg'),
            require('@/assets/Event/NYEParties/image_9.jpg'),
            ],
            "007":[
            require('@/assets/Event/FairyTale/image_1.jpg'),
            require('@/assets/Event/FairyTale/image_2.jpg'),
            require('@/assets/Event/FairyTale/image_3.jpg'),
            require('@/assets/Event/FairyTale/image_4.jpg'),
            require('@/assets/Event/FairyTale/image_5.jpg'),
            require('@/assets/Event/FairyTale/image_6.jpg'),
            require('@/assets/Event/FairyTale/image_7.jpg'),
            require('@/assets/Event/FairyTale/image_8.jpg'),
            require('@/assets/Event/FairyTale/image_9.jpg'),
            require('@/assets/Event/FairyTale/image_10.jpg'),
            require('@/assets/Event/FairyTale/image_11.jpg'),
            require('@/assets/Event/FairyTale/image_12.jpg'),
            require('@/assets/Event/FairyTale/image_13.jpg'),
            require('@/assets/Event/FairyTale/image_14.jpg'),
            require('@/assets/Event/FairyTale/image_15.jpg'),
            require('@/assets/Event/FairyTale/image_16.jpg'),
            require('@/assets/Event/FairyTale/image_17.jpg'),
            require('@/assets/Event/FairyTale/image_18.jpg'),
            require('@/assets/Event/FairyTale/image_19.jpg'),
            require('@/assets/Event/FairyTale/image_20.jpg'),
            require('@/assets/Event/FairyTale/image_21.jpg'),
            require('@/assets/Event/FairyTale/image_22.jpg'),
            require('@/assets/Event/FairyTale/image_23.jpg'),
            require('@/assets/Event/FairyTale/image_24.jpg'),
            require('@/assets/Event/FairyTale/image_25.jpg'),
            require('@/assets/Event/FairyTale/image_26.jpg'),
            require('@/assets/Event/FairyTale/image_27.jpg'),
            require('@/assets/Event/FairyTale/image_28.jpg'),
            require('@/assets/Event/FairyTale/image_29.jpg'),
            require('@/assets/Event/FairyTale/image_30.jpg'),
            require('@/assets/Event/FairyTale/image_31.jpg'),
            require('@/assets/Event/FairyTale/image_32.jpg'),
            require('@/assets/Event/FairyTale/image_33.jpg'),
            require('@/assets/Event/FairyTale/image_34.jpg'),
            require('@/assets/Event/FairyTale/image_35.jpg'),
            require('@/assets/Event/FairyTale/image_36.jpg'),
            require('@/assets/Event/FairyTale/image_37.jpg'),
            require('@/assets/Event/FairyTale/image_38.jpg'),
            require('@/assets/Event/FairyTale/image_39.jpg'),
            require('@/assets/Event/FairyTale/image_40.jpg'),
            require('@/assets/Event/FairyTale/image_41.jpg'),
            require('@/assets/Event/FairyTale/image_42.jpg'),
            require('@/assets/Event/FairyTale/image_43.jpg'),
            require('@/assets/Event/FairyTale/image_44.jpg'),
            require('@/assets/Event/FairyTale/image_45.jpg'),
            ],
            "008":[
            require('@/assets/Event/SheguangHu/image_1.jpg'),
            require('@/assets/Event/SheguangHu/image_2.jpg'),
            require('@/assets/Event/SheguangHu/image_3.jpg'),
            require('@/assets/Event/SheguangHu/image_4.jpg'),
            require('@/assets/Event/SheguangHu/image_12.jpg'),
            require('@/assets/Event/SheguangHu/image_6.jpg'),
            require('@/assets/Event/SheguangHu/image_7.jpg'),
            require('@/assets/Event/SheguangHu/image_8.jpg'),
            require('@/assets/Event/SheguangHu/image_9.jpg'),
            require('@/assets/Event/SheguangHu/image_10.jpg'),
            require('@/assets/Event/SheguangHu/image_11.jpg'),
            require('@/assets/Event/SheguangHu/image_5.jpg'),
            require('@/assets/Event/SheguangHu/image_13.jpg'),
            // require('@/assets/Event/SheguangHu/image_14.jpg'),
            require('@/assets/Event/SheguangHu/image_15.jpg'),
            // require('@/assets/Event/SheguangHu/image_16.jpg'),
            ],
        }
      };
    },
    methods: {
        onMouseEnter() {
                this.showNavBar = true;
            },
            onMouseLeave() {
                this.showNavBar = true;
            },
            handleNavigation(id) {
                this.$router.push({ name: id });
                console.log("Handling navigation to:", id);
            },
        backToList() {
            this.$router.push({ name: "eventList" })
            //this.$emit('navigate', "eventList"); // 发出 `navigate` 事件，传递点击的id
            console.log("检测到点击,back to event list")
        },
        updateSelectedItem(item){
            this.item = item
        },
        getTextById(id) {
            const textfolder = this.folders.find(item => item.id === id);
            return textfolder ? textfolder.text : null; // 如果找不到，返回 null
        },
        loadPhotos() {
            const photos = this.images[this.item];
            
            // 根据屏幕宽度调整列数
            const columnCount = window.innerWidth < 768 ? 2 : 4;
            
            // 初始化列数
            this.columns = Array.from({ length: columnCount }, () => []);

            // 将照片分配到列中
            photos.forEach((photo, index) => {
                this.columns[index % columnCount].push(photo);
            });
        }
    },
    mounted() {
        //获取router中传入的参数参数来设置选中Item
        if(this.$route.params.item){
            this.updateSelectedItem(this.$route.params.item)
        }
        this.title = this.getTextById(this.item)
        this.loadPhotos();
        // 添加窗口调整大小事件监听器
        window.addEventListener("resize", this.loadPhotos);
    },
    beforeUnmount() {
        // 移除事件监听器以防止内存泄漏
        window.removeEventListener("resize", this.loadPhotos);
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    
    .background{
        height: 100vh;
        width: 100vw;
        background: url(../assets/backgroundpure.png) no-repeat center center;
        background-size: cover;
        z-index: -1; /* 确保背景位于内容之下 */
        /*overflow: hidden;*/

    }
    .layer{
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        /*overflow: hidden;*/
    }
    .eventTitle{
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 48px;
        
    }
    .line{
        margin-top: 8px;
        margin-bottom: 16px;
        height: 6px;
        background: linear-gradient(90deg,rgba(186, 162, 115, 1),  rgba(81, 69, 46, 1));
    }
    .eventDetailInfo{
        margin-top: 80px;
        padding-top: 16px;
        width: 85%;
    }
    .photo-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0px;
    }
    .photo-grid {
        display: flex;
        gap: 32px;
        overflow-y: auto;
    }
    .photo-area{
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
    }
    .photo-top{
        width: 100%;
        height: 8px;
        background-color: black;
    }
    .photo-bottom{
        width: 100%;
        height: 8px;
        background-color: black;
    }
    .photo-middle{
        display: flex;
        flex-direction: row;
    }
    .photo-left{
        width: 32px;
        height: auto;
        background-color: black;
        color: rgb(220, 220, 220);
        font-size: 0.6rem;
        /* transform: rotate(90deg); */
        writing-mode: vertical-lr;
        text-align: end;
        line-height: 32px;
    }
    .photo-right{
        width: 32px;
        height: auto;
        background-color: black;
        color: rgb(220, 220, 220);
        font-size: 0.6rem;
        /* transform: rotate(90deg); */
        writing-mode: vertical-lr;
        text-align: start;
        line-height: 32px;
    }
    .photo {
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 0px;
    }
    .title{
        color:rgba(186, 162, 115, 1);
        font-size:1.5rem;
        margin-left: 16px;
    }
    .close-button{
        border: none;
        overflow: hidden;
        margin:6px;
        background-color: rgba(0, 0, 0, 0.2);
        color:rgba(186, 162, 115, 0.0);

    }
    .close-button:hover{
        background-color:rgb(96, 96, 96, 0.5);
        color:rgb(186, 162, 115);
    }

    @media (max-width: 768px) {
        .background{
            height: auto;
            width: 100vw;
            background: url(../assets/backgroundpure.png) repeat center center;
            background-size:auto;
            z-index: -1; /* 确保背景位于内容之下 */
            display: flex;
            align-items:center;
        }
        .photo-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr); /* 使用两列布局 */
            gap: 8px;
        }
        .photo-left{
            width: 4px;
        }
        .photo-right{
            width: 4px;
        }
        .photo-top{
            height: 4px;
        }
        .photo-bottom{
            height: 4px;
        }
        .eventDetailInfo{
            margin-top: 48px;
            width: 90%;
        }
        .title{
            font-size:1.3rem;
            margin-left: 4px;
        }
    }
  </style>
  